import React from 'react';
import { DropdownItem } from '@weezevent/nacre';
import { usePermissions } from '../../../user/permissions';
import { useTranslation } from 'react-i18next';

export default function LinkPaymentAction({ order, paymentPlan }) {
    const permissions = usePermissions();
    const { t } = useTranslation();

    //available if event no closed, no over, no deleted and without seating
    const is_available = React.useMemo(() => {
        return ['valid', 'reservation'].includes(order.status) && order.is_payment_plan && paymentPlan;
    }, [permissions, paymentPlan, order]);

    const onSubmitAction = React.useCallback(() => {
        const lyriaUrl = process.env.NODE_ENV === 'production' ? 'https://payment.weezevent.com' : 'https://payment-sandbox.weezevent.be';
        window.open(`${lyriaUrl}/pay-over-time/${paymentPlan.id}`, 'paymentTab');
    }, [paymentPlan]);

    if (!is_available) {
        return null;
    }

    return <DropdownItem item={t('paymentinvoicing.payment_link_cta')} onClick={onSubmitAction} />;
}
